module.exports = __webpack_public_path__ + "static/media/PS-01.82ca7529.svg";